//event handler: https://gist.github.com/datchley/37353d6a2cb629687eb9
export default class EventEmitter {
    constructor() {
        this.listeners = new Map();
    }
    addListener(label, callback) {
        this.listeners.has(label) || this.listeners.set(label, []);
        this.listeners.get(label).push(callback);
    }

    removeListener(label, callback) {
        let listeners = this.listeners.get(label),
            index;

        if (listeners && listeners.length) {
            index = listeners.reduce((i, listener, index) => {
                let isFunction = this.isFunction(listener);
                if (!listener) return -1;
                if (!callback) return -1;
                return (isFunction && listener == callback) ? i = index : i;
            }, -1);
            if (index == -1) {
                index = listeners.reduce((i, listener, index) => {
                    let isFunction = this.isFunction(listener);
                    if (!listener) return -1;
                    if (!callback) return -1;
                    return (isFunction && listener.toString() == callback.toString()) ? i = index : i;
                }, -1);
            }

            if (index > -1) {
                listeners.splice(index, 1);
                this.listeners.set(label, listeners);
                return true;
            }
        }
        return false;
    }
    removeAllListener() {
        this.listeners = new Map();
    }
    isFunction(obj) {
        return typeof obj == 'function' || false;
    }

    emit(label, ...args) {
        let allListeners = this.listeners.get("all");
        if (allListeners) {
            if (allListeners && allListeners.length) {
                allListeners.forEach((listener) => {
                    listener(label, ...args);
                });
            }
        }


        let listeners = this.listeners.get(label);

        if (listeners && listeners.length) {
            listeners.forEach((listener) => {
                listener(...args);
            });
            return true;
        }
        return false;
    }
}
